var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bet)?_c('span',[(_vm.socketUpdate && _vm.anyOddChangedWithAgainConfirmation)?_c('div',{staticClass:"odd-updated-area",class:{
      socketUpdate: _vm.socketUpdate,
      anyOddChangedWithAgainConfirmation: _vm.anyOddChangedWithAgainConfirmation,
    }}):_vm._e(),_c('div',{staticClass:"odd-updated-area d-none",class:{
      isAccepted: _vm.isAccepted,
    }},[_c('div',{staticClass:"left-text mr-2"},[_vm._v("\n      "+_vm._s(_vm.$t('BetSlip.OddsUpdated'))+"\n    ")]),_c('a',{staticClass:"right-button",on:{"click":function($event){return _vm.acceptBet()}}},[_vm._v("\n      "+_vm._s(_vm.$t('ACCEPT'))+"\n    ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }